"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutcomeResult = exports.OutcomeOrigin = void 0;
var OutcomeOrigin;
(function (OutcomeOrigin) {
    OutcomeOrigin["Evaluated"] = "Evaluated";
    OutcomeOrigin["Fallback"] = "Fallback";
})(OutcomeOrigin = exports.OutcomeOrigin || (exports.OutcomeOrigin = {}));
var OutcomeResult = /** @class */ (function () {
    function OutcomeResult(outcome, origin) {
        this.outcome = outcome;
        this.origin = origin;
    }
    return OutcomeResult;
}());
exports.OutcomeResult = OutcomeResult;
